export default __webpack_public_path__ + "static/media/nordics.65535755.png";